import { Reducer } from 'redux'; 
import * as types from './types';
import { ArcadeCabinetsState } from './interfaces';
import produce from 'immer';

const arcadeCabinetsState: ArcadeCabinetsState = {
    cabinet: {
        arcadeId: undefined,
        description: '',
        cabinetId: undefined,
        romId: undefined,
        name: '',
        metaData: '{}',
        metaDataValues: '{}',
        bannerImage: null,
        image: null,
    },
    list: []
};

const setArcadeCabinetList = produce((draft, action) => {
    draft.list = action.list;
});
const setArcadeCabinet = produce((draft, action) => {
    draft.cabinet = action.cabinet;
});
const resetCabinetEditor = produce(draft => {
    draft.cabinet = arcadeCabinetsState.cabinet;
});
const setArcadeCabinetValue = produce((draft, action) => {
    draft.cabinet[ action.name ] = action.value;
});
const selectRom = produce((draft, action) => {
    draft.cabinet = { ...arcadeCabinetsState.cabinet, ...action.rom };
});

export const cabinetsReducer: Reducer<ArcadeCabinetsState> = (state = arcadeCabinetsState, action) => {
    switch (action.type) {  
        case types.ARCADE_CABINETS__SET_CABINET_LIST:
            return setArcadeCabinetList(state, action);
        case types.ARCADE_CABINETS__SET_CABINET:
            return setArcadeCabinet(state, action);
        case types.ARCADE_CABINETS__CLEAR_CABINET:
            return resetCabinetEditor(state);
        case types.ARCADE_CABINETS__SET_CABINET_VALUE:
            return setArcadeCabinetValue(state, action);
        case types.ARCADE_CABINETS__SELECT_ROM:
            return selectRom(state, action);
        default:
            return state;
    }
};
